<template>

	<toolbar>
		<router-link v-if="backLink" :to="backLink" class="btn btn-link">
			<i class="fa fa-caret-left fa-2x"></i>
			<h2 v-if='heading' class="toolbar-heading"><i class="fa fa-truck"></i> {{heading}}</h2>
		</router-link>
		<h2 v-else-if='heading' class="toolbar-heading"><i class="fa fa-truck"></i> {{heading}}</h2>

		<div class="controls">
			<slot></slot>
		</div>
		
	</toolbar>

</template>

<script>
import Toolbar from "@/layout_fragments/Toolbar"
import NavTabs from "@/layout_fragments/NavTabs"

export default {

	name: 'EquipmentToolbar',
	components: {
		Toolbar,
		NavTabs
	},
	props: ["heading","backLink"],
}
</script>